import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { AccountCompanyControllerModule } from './controllers/AccountCompanyController';

export const AccountCompanyView = angular
  .module('acme.view.application.account.company', [uiRouter, 'ui.bootstrap', AccountCompanyControllerModule])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.account.company',
      url: '/company',
      views: {
        'subview-main': {
          controller: 'AccountCompanyController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/account/company/company.tpl.html',
        },
      },
      data: {
        pageTitle: 'Company Profile',
        permissions: ['COMPANY_PROFILE_VIEW'],
        roles: ['admin'],
      },
    });
  }).name;
